import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../core";
import { AuthContextConfigurationGetDto } from "../dto";

@Injectable({
  providedIn: "root"
})
export class ConfigurationService {
  protected serviceUrl = "Configuration";

  constructor(private api: ApiService) {}

  getContext(): Observable<AuthContextConfigurationGetDto> {
    return this.api.get(`${this.serviceUrl}/context`);
  }

  navigateHomeUrl(): Observable<string> {
    return this.api.get(`${this.serviceUrl}/navigateHomeUrl`);
  }
}
